import { Box, Button, Paper, Stack, Typography, useTheme } from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { Table } from 'react-bootstrap'
// import Pagination from './general/Pagination'
// import ExportContent from './ExportContent'
import generatePDF from 'react-to-pdf';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import { PASS_KEY, WEB_KEY, BaseUrl } from '../../api/AxiosApi' 

import ExportContent from '../ExportContent';
import Pagination from '../general/Pagination';
import { AuthenticationContext } from '../../context/AuthenticationContext';
let Radiation;
export default function WmsTab3Table({ radiationName, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { palette, shape: { spacing, borderRadius } } = useTheme()
    const tableRef = useRef(null);

    // console.log('Table', TableData)
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(15);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(TableData.length / recordsPerPage)


    const LOGIN_ID = localStorage.getItem("LoginID") ?? ""

    const LOC_CODE = localStorage.getItem("LCODE") ?? ""
    
    const currentRecords1 = TableData;
    
     const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    if (TableData?.length > 0) {
        Radiation = TableData[0]
    }


   

    function genPDF() {
        const textX = 20; // Left margin
        const textY = 20; // Top margin
        const logoWidth = 50;
        const logoHeight = 30;
    
        const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });
    
        // --- IMAGES ---
        const imgData = require('../../assets/img/logos/logo 2.png'); // center logo
        // optional right-side logo (dynamic)
        // const rightImg = require('../../assets/img/logos/rightImg.png');
    
        const pdfWidth = pdf.internal.pageSize.getWidth();
    
        // --- LEFT SIDE TEXT (Plant Info) ---
        pdf.setFontSize(15);
        pdf.setFont("helvetica", "bold");
        pdf.text(`Plant Name/User Name: ${LoggedInUserInfo?.username || ""}`, textX, textY + 10);
    
        pdf.setFontSize(10);
        pdf.text(`Plant Capacity : ${LoggedInUserInfo?.PLANT_CAPACITY || ""}`, textX, textY + 16);
        pdf.text(`Plant Address : ${LoggedInUserInfo?.Address || ""}`, textX, textY + 22);
    
        // --- CENTER LOGO ---
        const logoX = (pdfWidth - logoWidth) / 2;
        pdf.addImage(imgData, 'JPEG', logoX, textY, logoWidth, logoHeight);
    
        // --- RIGHT SIDE LOGO (optional) ---
        if (ImageUrl) {
            const rightImgWidth = 100;
            const rightImgHeight = 35;
            const rightX = pdfWidth - rightImgWidth - 20;
            pdf.addImage(ImageUrl, 'JPEG', rightX, textY, rightImgWidth, rightImgHeight);
        }
    
        // --- TITLE ---
        const title = `${radiationName} ${ValueOf2}`;
        pdf.setFontSize(12);
        const titleWidth =
            pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const titleX = (pdfWidth - titleWidth) / 2;
        pdf.text(title, titleX, textY + logoHeight + 15);
    
        // --- TABLE ---
        pdf.autoTable({
            html: '#table-to-pdf1',  // your old table ID
            startY: textY + logoHeight + 25,
            theme: "grid",
            styles: { fontSize: 8, cellPadding: 2 },
            headStyles: { fillColor: [1, 59, 123] },
            pageBreak: "auto",
            margin: { left: 20, right: 20 }
        });
    
        // --- SAVE FILE ---
        pdf.save(`Solar Radiation To ${ValueOf2} ${radiationName}.pdf`);
    }
    

    return (
        <Box>
            {
                radiationName == 'Wind Direction' ? <Typography color={'error.main'} textAlign={'center'}>Nothing to show</Typography> :
                    currentRecords1?.length > 0 ? <>
                        <ExportContent
                            excelTableRef={tableRef}
                            onGenPdf={genPDF}
                            ExcelExportFileName={`Solar Radiation To ${ValueOf2} ${radiationName}`}
                            title={radiationName}
                            filterContent={
                                <Stack flex={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Box flex={1} columnGap={2} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                        <Stack direction={'row'} alignItems={'center'} columnGap={1}>
                                            <input type='date' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
                                        </Stack>
                                        <Typography variant='body1' >To</Typography>
                                        <input type='date' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
                                        {/* <Button onClick={onRefreshData} variant='contained' sx={{ color: 'background.default', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button> */}
                                    </Box>
                                </Stack>
                            }
                        />
                        <Box flexGrow={1}>

                            <>
                                <Table style={{}} ref={tableRef} id='table-to-pdf' striped bordered hover responsive>
                                    <thead style={{}}>
                                        <tr style={{ textAlign: 'center' }}>
                                            {
                                                TableHead?.map((item, index) => {
                                                    return (
                                                        <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentRecords?.map((item, index) => {
                                                // console.log('data', item)
                                                return (
                                                    <tr key={index} style={{ textAlign: 'center' }}>
                                                        <td>{item?.Sn}</td>
                                                        <td>{item?.Date}</td>
                                                        {
                                                            radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? <td>{item[`${radiationName}`]}</td> : null
                                                        }

                                                        {/* <td>{item[`${radiationName}`]}</td> */}
                                                        {
                                                            radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRRADIANCE' : 'MIN_VALUE']}</td>

                                                        }
                                                        {radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['MIN_DATE_TIME']}</td>}

                                                        {/* <td>{item?.MIN_DATE_TIME}</td> */}

                                                        {
                                                            radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRR.TIME' : 'MAX_VALUE']}</td>

                                                        }

                                                        {radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['MAX_DATE_TIME']}</td>}


                                                        {
                                                            radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['AVG_VALUE']}</td>
                                                        }


                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
 
                                <Table style={{display:"none"}} ref={tableRef} id='table-to-pdf1' striped bordered hover responsive>
                                    <thead style={{}}>
                                        <tr style={{ textAlign: 'center' }}>
                                            {
                                                TableHead?.map((item, index) => {
                                                    return (
                                                        <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentRecords1?.map((item, index) => {
                                                // console.log('data', item)
                                                return (
                                                    <tr key={index} style={{ textAlign: 'center' }}>
                                                        <td>{item?.Sn}</td>
                                                        <td>{item?.Date}</td>
                                                        {
                                                            radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? <td>{item[`${radiationName}`]}</td> : null
                                                        }

                                                        {/* <td>{item[`${radiationName}`]}</td> */}
                                                        {
                                                            radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRRADIANCE' : 'MIN_VALUE']}</td>

                                                        }
                                                        {radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['MIN_DATE_TIME']}</td>}

                                                        {/* <td>{item?.MIN_DATE_TIME}</td> */}

                                                        {
                                                            radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRR.TIME' : 'MAX_VALUE']}</td>

                                                        }

                                                        {radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['MAX_DATE_TIME']}</td>}


                                                        {
                                                            radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['AVG_VALUE']}</td>
                                                        }


                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>

                                <Box
                                    sx={{ display: 'flex', justifyContent: 'end' }}
                                >
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </Box>
                            </>

                        </Box>
                    </>

                        : <>
                            <Typography variant='body2' p={10} color={'error.main'} textAlign={'center'}>Data Not Found</Typography>
                        </>
            }
        </Box>
    )
}
